import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ReportingCompetingBidderSearchService } from '@services/http/clients/reporting-app/reporting-competing-bidder-search.service';
import { GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { CustomMenuItemComponent } from '../../../custom-menu-item/custom-menu-item.component';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-competing-bidder-form-editor',
    templateUrl: './report-competing-bidder-form-editor.component.html',
    styleUrls: ['./report-competing-bidder-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportCompetingBidderFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent, CustomMenuItemComponent]
})
export class ReportCompetingBidderFormEditorComponent extends FormEditorBase<number[] | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Competing Bidder');
    placeholderText = input<string>('Search Competing Bidder');

    private readonly competingBidderSearchService = inject(ReportingCompetingBidderSearchService);

    async ngOnInit(): Promise<void> {
        const selectedIds = this.selectedValue();
        if (selectedIds?.length) {
            const selected = await this.competingBidderSearchService.getByIds(selectedIds);
            this.selectedItems.set(selected);
        }
    }

    protected override async onEntityTextChange(text: string): Promise<void> {
        if (!text?.trim()) {
            this.items.set([]);
            return;
        }
        const bidders = await this.competingBidderSearchService.search(text);
        this.items.set(bidders);
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(): any[] {
        return this.selectedItems() ?? [];
    }
}
